import Image from '@/components/Image';
import { useStore } from '@/providers/app-store-provider';
import { useTranslations } from '@/i18n/use-translations';
import { useMemo } from 'react';
import { Product } from './ProductCard';

const Relate = ({
  productData,
  onClick = () => {},
  correlationIndex,
  showCorrelationCount = 3,
  onMouseEnter = () => {},
  onMouseLeave = () => {},
  correlation = [],
}: {
  productData: Product;
  onClick: (index: number) => void;
  correlationIndex: number;
  showCorrelationCount?: number;
  onMouseEnter?: (item: Product['correlation'][number]) => void;
  onMouseLeave?: () => void;
  correlation: Product['correlation'];
}) => {
  const t = useTranslations('product');
  const tGoodsDetail = useTranslations('goodsDetail');
  const { waiMode } = useStore((state) => state);
  const correlationList = useMemo(() => {
    return correlation.slice(0, showCorrelationCount);
  }, [correlation, showCorrelationCount]);
  return (
    <ul
      className="mt-12 pb-2 w-full h-[20px] flex"
      role="radiogroup"
      aria-label={tGoodsDetail('relationColorsGroup')}
    >
      {correlationList.map((item, index) => {
        const colorName = item.product_frame_color_name || '';
        const isSelected = index === correlationIndex;
        const optionAriaLabel = isSelected
          ? tGoodsDetail('relationOptionSelectedAria', { name: colorName })
          : tGoodsDetail('relationOptionAria', { name: colorName });
        return (
          <li className="pr-8 h-[20px] w-[20px] box-content" key={item.id}>
            <div
              role="radio"
              aria-checked={isSelected}
              aria-label={optionAriaLabel}
              tabIndex={0}
              className={`flex items-center justify-center h-[20px] w-[20px] cursor-pointer hover:border-auxiliary-light-gray-blue hover:border-solid rounded-full box-content border-1 border-transparent ${isSelected ? '!border-primary-purple-active' : ''}`}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                onClick(index);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onClick(index);
                }
              }}
              onMouseEnter={() => onMouseEnter(item)}
              onMouseLeave={onMouseLeave}
            >
              <div
                className={`w-[18px] h-[18px] rounded-full border-1 border-solid border-auxiliary-light-gray-blue overflow-hidden ${isSelected ? 'border-primary-white' : ''}`}
              >
                <Image
                  src={item.product_frame_color_main_url}
                  width={16}
                  height={16}
                  alt={item.product_frame_color_name}
                  aria-hidden
                  className="rounded-full object-cover w-[16px] h-[16px]"
                />
              </div>
            </div>
          </li>
        );
      })}
      {productData.correlation.length > showCorrelationCount && (
        <li
          className={`leading-[20px] pl-2 text-12 ${waiMode ? 'text-primary-black' : 'text-auxiliary-dark-gray'}`}
        >
          {t('relate.more', { count: productData.correlation.length - showCorrelationCount })}
        </li>
      )}
    </ul>
  );
};

export default Relate;
